<template>
  <div class="home">
    <div class="listBox" v-for="(item,index) in list" :key="index">
      <div v-if="index === 0" class="title">
        <p>{{item.subtitle}}</p>
        <p>{{item.describe}}</p>
      </div>
      <div v-else>
        <h4>{{item.title}}</h4>
        <p v-for="(p,i) in item.describe" :key="i">{{p}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          title: 'e充电充值退费协议',
          subtitle: '更新时间：2024年12月23日',
          describe:
            '尊敬的用户，欢迎使用e充电（包括e充电APP、e充电小程序）账户充值功能，请您在进行充值前仔细阅读本协议，在点击"立即充值"按钮后即表示您已阅读、理解并同意本协议项下的全部条款。'
        },
        {
          title: '一、充值服务说明',
          describe: [
            '1.1 用户充值后，账户总余额为充值金额与赠送金额的和，充值金额为用户充值实际支付金额，赠送金额为充值活动赠送的额度。充值金额和赠送金额将显示在用户e充电账户的余额中。',
            '1.2 为保障用户资金安全及平台运营秩序，个人用户账户充值需遵循以下规则:',
            '1)个人实名账户充值上限:人民币2000元;',
            '2)单笔充值上限:人民币1000元;',
            '3)单日充值操作次数上限:5次，超过5次以上需经过人工审核后方可继续充值;',
            '4)个人未实名账户充值上限:人民币1000元;当您的账户余额超过人民币1000元时，如需进行充值操作，必须按照本平台要求完成实名认证。',
            '1.3 用户参与充值优惠活动的规则以活动页面展示为准。'
          ]
        },
        {
          title: '二、账户余额及使用说明',
          describe: [
            '2.1 账户余额可用于支付e充电app或小程序提供的充电服务的充电费、充电服务费，e充电app提供的交电费的费用，e充电app提供的每日商城的费用等。',
            '2.2 账户总余额为可用余额与冻结余额的和。冻结金额包括充电预冻结金额、未生效的充值赠送金额等。',
            ' 2.2.1 充电预冻结金额：使用预付费充电时，在充电过程中会冻结部分金额，充电完成后将剩余金额返还至余额账户，每笔预充金额的冻结时间不超过96小时。',
            ' 2.2.2 未生效的充值赠送金额：当本次充值的实付金额消费完之后，参加充值活动赠送的金额为可用状态；若实付金额未消费完，此笔充值赠送金额暂为冻结状态。',
            '2.3 如您的账户余额同时有充值金额和赠送金额时，将优先使用所有的充值金额后，再使用赠送金额。',
            '2.4 当您的账户余额不足及欠费时，可能导致部分服务受到影响或导致服务终止，由您自行承担责任，本平台对此不承担责任。',
            '2.5 账户余额有效期为自充值之日起至使用完毕为止。'
          ]
        },
        {
          title: '三、充电开票说明',
          describe: [
            '3.1 用户可在本平台按充电消费记录或车电服务包购买记录开具发票。',
            '3.2 充值赠送金额均不支持开票。',
            '3.3 充电消费记录的实际可开票金额=订单实付金额-订单不可开票金额-退补电费金额；订单不可开票金额=活动赠送e卡支付金额+已开过发票的e卡支付金额+车电服务包支付金额+充值赠送金额。'
          ]
        },
        {
          title: '四、余额退费说明',
          describe: [
            '4.1 本平台仅支持可退费金额全额退费，赠送金额不可退费。退费方式包括快速退费和普通退费（e充电APP 3.8.160及以上版本将升级至银联超期退费），您可根据情况自行选择。',
            '4.2 如您申请快速退费，申请成功后退费金额将于3个工作日内退还至您的充值账户（注意：若您充值时享受过第三方支付补贴，退费后补贴可能会被第三方收回，具体以补贴方解释为准）。在本平台，12个月内的支付宝、微信支付、一网通支付、云闪付、数字人民币、和包支付等支付方式的充值记录可申请快速退费，不满足以上情况的充值、或使用其他充值方式的充值则无法申请快速退费。',
            '4.3 如您申请普通退费，审核成功后退费金额将于15个工作日内退还至您填写的银行卡账户。普通退费成功后，充值记录对应的活动赠送金额将清空。您可以在退费记录查看退费信息和审核进度。',
            '4.4 如您APP升级至3.8.160及以上版本时，普通退费功能将相应升级为银联超期退费功能，退费时需要您按照页面银联提示完成相关身份及银行卡认证，认证通过后退款将于三个工作日内退回至您验证通过的银行卡中。'
          ]
        },
        {
          title: '五、注销说明',
          describe: [
            '5.1 如您注销e充电账号，需先将账户余额消费完或完成账户退费申请后，申请账号注销。'
          ]
        },
        {
          title: '六、法律适用及争议解决',
          describe: [
            '6.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部分则仍具有法律效力。如遇本协议有关的某一特定事项缺乏明确法律规定，则应参照通用国际商业惯例和（或）行业惯例。',
            '6.2 因双方就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均有权向国网智慧车联网技术有限公司所在地有管辖权的人民法院起诉。'
          ]
        },
        {
          title: '七、特别说明',
          describe: [
            '7.1 本平台有权在必要时变更本协议条款，您可以在e充电APP或小程序的相关页面查阅最新版本的协议条款。本协议条款变更后，如果您继续使用e充电服务，即视为您已接受变更后的协议。'
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  text-align: center;
}
</style>
